<template>

  <div
    class="feed-content">

    <div class="photo">
      <Avatar
        :src="imgSrc"
        :name="activity.candidate.name"
        size="40px"
        radius="20px"
        resize="100x100x1" />
    </div>
    
    <div class="content">
      
      <div
        v-if="permissions.includes('manage_candidates')"
        class="feed-actions dropdown">
        <button
          class="btn btn-sm btn-light"
          type="button"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false">
          <i class="fas fa-chevron-down" />
        </button>
        <div class="dropdown-menu dropdown-menu-right">
          <button
            class="dropdown-item"
            @click="deleteIntervoice(activity.intervoice._id)">
              <i class="fas fa-times" /> {{ $t('Remove') }}
            </button>
        </div>
      </div>

      <div>
        {{ $t('Voice AI Interview Responded') }}
      </div>

      <audio class="mt-2" controls>
        <source :src="activity.intervoice.recording_media_id.url" type="audio/wav">
        Seu navegador não suporta o player de áudio.
      </audio>

      <div class="mt-2">
        <div v-if="!showAll">{{ summaryShort }} <a href="javascript:void(0)" @click="showAll=true">{{ $t('Show summary') }}</a></div>
        <div v-if="showAll">
          <div style="white-space: pre-wrap;" class="mb-2">{{ activity.intervoice.summary }} <a href="javascript:void(0)" @click="showAll=false">{{ $t('Hide summary') }}</a></div>
        </div>
      </div>

      <div
        v-if="showAll"
        class="mt-2">
        <div class="form-group">
          <div class="form-check">
            <input
              class="form-check-input"
              type="checkbox"
              id="showTranscript"
              v-model="showTranscript">
            <label
              class="form-check-label"
              for="showTranscript">
              {{ $t('Show transcription') }}
            </label>
          </div>
        </div>
        <div
          v-if="showTranscript"
          class="card mb-2">
          <div class="card-body">
            <div class="mb-3"><b>Transcript</b></div>
            <div style="white-space: pre-wrap;">{{ activity.intervoice.transcript }}</div>
          </div>
        </div>
      </div>

      <div class="mt-2">
        <small>
          <span
            v-tooltip="$d(new Date(activity.created_at), 'long')">
            {{ $d(new Date(activity.created_at), 'short') }}
            </span>
          <span>
            -
            </span> 
          <router-link
            class="link-discreet"
            :to="{path: '/job/' + activity.job._id }">
            {{ activity.job.title }}
            </router-link>
        </small>
      </div>
    </div>

  </div>

</template>

<script>
import config from '@/config'
import Avatar from '@/components/Parts/Avatar'

export default {
  name: 'CandidateFeedIntervoiceItem',
  components: {
    Avatar
  },
  props: {
    activity: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      showAll: false,
      showTranscript: false
    }
  },
  computed: {
    permissions () {
      return this.$store.getters.getPermissions
    },
    imgSrc () {
      const defaultImageUrl = config.default_image_url.candidate
      const url = this.activity.candidate.photo_media_url
      return url && !url.includes(defaultImageUrl) ? url : null
    },
    summaryShort () {
      if (!this.activity.intervoice) {
        return ''
      }
      if (!this.activity.intervoice.summary) {
        return ''
      }
      const words = this.activity.intervoice.summary.split(' ')
      return words.slice(0, 20).join(' ') + (words.length > 20 ? '...' : '')
    }
  },
  created () {
  },
  methods: {
    deleteIntervoice (id) {
      const deleteAction = () => {
        this.loading = true

        this.$store
        .dispatch('deleteIntervoice', id)
        .then((result) => {
          return this.$store.dispatch('deleteActivity', this.activity._id)
        })
        .then((result) => {
          this.loading = false
          this.$emit('deleted', result)
        })
      }

      this.$store
      .dispatch('setAlertModal', {
        action: deleteAction
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Candidate/Feed/CandidateFeedIntervoiceItem.vue